import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	IconButton,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { useState } from "react";
import RxButton from "../../../components/RxButton";
import RxPaper from "../../../components/RxPaper";
import RxTextField from "../../../components/RxTextField";
import RxTitleSeperator from "../../../components/RxTitleSeperator";
import RxTypography from "../../../components/RxTypography";
import styles from "./CouponDialog.module.css";

interface CouponDialogProps {
	open?: boolean;
	title: string;
	coupons?: string[];
	applyCoupon: (code: string) => void;
	removeCoupon: (code: string) => void;
	onClose: () => void;
}

const CouponDialog = (props: CouponDialogProps) => {
	const [couponCode, setCouponCode] = useState("");
	const [error, setError] = useState(false);

	return (
		<Dialog
			fullWidth
			open={props.open ?? true}
			onClose={props.onClose}
			maxWidth="md"
		>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<Grid
					container
					spacing={0}
					direction="row"
					justifyContent="center"
					alignItems="center"
					alignContent="center"
				>
					<Grid item xs={12} sm={12}>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={6}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<DialogContentText>
											<RxTypography
												variant={"body1"}
												align="justify"
												label={
													"Lütfen sepetinize uygulamak istediğiniz indirim kodunu giriniz."
												}
											/>
										</DialogContentText>
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={8}>
										<RxTextField
											fullwidth
											variant="outlined"
											label="İndirim Kodu"
											placeholder="Kupon Kodu"
											size="small"
											value={couponCode}
											onChange={(e) => {
												setCouponCode(e.target.value);
												if (e.target.value.length > 0) {
													setError(false);
												}
											}}
											error={error}
										/>
									</Grid>
									<Grid item xs={4} sm={4}>
										<RxButton
											fullWidth
											color="primary"
											variant="contained"
											label="EKLE"
											onClick={() => {
												if (couponCode.length > 0) {
													props.applyCoupon(couponCode);
													setCouponCode("");
													setError(false);
												} else {
													setError(true);
												}
											}}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={6}>
								<RxPaper className={styles.couponPaper}>
									<>
										<Grid container spacing={1}>
											<Grid item xs={12} sm={12}>
												<RxTitleSeperator
													titleLabel="Eklenen İndirim Kodları:"
													titleVariant="body1"
												/>
											</Grid>
										</Grid>
										<Grid container spacing={1}>
											{props.coupons?.map((item, index) => {
												return (
													<>
														<Grid
															key={"first-grid-" + index}
															item
															xs={1}
															sm={1}
														>
															<IconButton
																key={"icon-button-" + index}
																aria-label="delete"
																name={item}
																size="small"
																onClick={() => {
																	props.removeCoupon(item);
																}}
															>
																<ClearIcon
																	key={"icon-" + index}
																	fontSize="inherit"
																	className={
																		styles.cancelButton
																	}
																/>
															</IconButton>
														</Grid>
														<Grid
															key={"second-grid-" + index}
															item
															xs={5}
															sm={5}
														>
															<RxTypography
																key={"typography-" + index}
																variant={"subtitle2"}
																align="left"
																label={item}
																className={styles.marginTop}
															/>
														</Grid>
													</>
												);
											})}
										</Grid>
									</>
								</RxPaper>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<RxButton
					color="primary"
					variant="contained"
					label="TAMAM"
					onClick={props.onClose}
					className={styles.confirmButton}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default CouponDialog;
